import { Button, DeleteModal, StickyActionBar, useToggleObject, useAlert } from '@uplift/ui-v2';
import { useFormikContext } from 'formik';
import { useMutation } from '@tanstack/react-query';
import { deleteDischargeNote } from '@uplift/api';
import { useHistory } from 'react-router';
import { providerPatientRoute } from '@uplift/constants';
import { useCallback } from 'react';

export type DischargeNoteActionBarProps = {
  noteId: string;
  patientId: string;
  onNext: () => void;
  nextText: string;
  onSaveAndFinishLater: () => void;
  isLoading?: boolean;
};

export type DischargeNoteModalView = 'delete' | 'submitAndCancel' | null;

export const DischargeNoteActionBar: React.VFC<DischargeNoteActionBarProps> = props => {
  const snackbar = useAlert();
  const { open, close, value: isOpen } = useToggleObject();
  const history = useHistory();
  const formik = useFormikContext();
  const deleteNoteMutation = useMutation({
    mutationFn: () => deleteDischargeNote(props.noteId),
    onSuccess: async () => {
      history.replace(providerPatientRoute.createLink({ patientId: props.patientId }));
      snackbar.success('Discharge note deleted');
    }
  });

  const isLoading = formik?.isSubmitting || props.isLoading;

  const onCloseModal = useCallback(async (proceed: boolean) => {
    if (proceed) {
      await deleteNoteMutation.mutateAsync();
    }

    close();
  }, [ close, deleteNoteMutation ]);

  return (
    <>
      <DeleteModal
        open={isOpen}
        onClose={onCloseModal}
        loading={deleteNoteMutation.isLoading}
        title="Delete this note?"
      />


      <StickyActionBar
        leftContainer={(
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => open()}
            loading={isLoading}
          >
            Delete Note
          </Button>
        )}
      >
        <Button
          variant="outlined"
          color="secondary"
          disabled={isLoading}
          onClick={() => props.onSaveAndFinishLater()}
          loading={isLoading}
        >
          Save and finish later
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => props.onNext()}
          loading={isLoading}
        >
          {props.nextText}
        </Button>
      </StickyActionBar>
    </>
  );
};
